<template>
  <v-card class="pa-5 my-0" variant="tonal">
    <div class="d-flex flex-column flex-md-row">
      <v-text-field
        clearable
        :prepend-inner-icon="mdiMagnify"
        v-model="filter.search"
        single-line
        density="compact"
        class="mr-md-5 text-black"
        @update:modelValue="filterChanged"
      >
        <template v-slot:label>
          <span> {{ $t('point-of-sale.filter-form.label.search') }} </span>
        </template>
      </v-text-field>
      <v-select
          clearable
          multiple
          :label="$t('point-of-sale.filter-form.label.store')"
          :placeholder="$t('global.text.all.f')"
          class="mr-md-5 text-black"
          v-model="filter.store"
          :items="stores"
          item-title="name"
          return-object
          single-line
          density="compact"
          @update:modelValue="filterChanged"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 1">
            <span>{{ item.title }}</span>
          </v-chip>
          <span
              v-if="index === 1"
              class="text-grey text-caption align-self-center"
          >
            (+{{ filter.store.length - 1 }} {{ $t('global.text.others') }})
          </span>
        </template>
      </v-select>
      <v-select
          clearable
          multiple
          class="text-black"
          :label="$t('point-of-sale.filter-form.label.department')"
          :placeholder="$t('global.text.all.m')"
          v-model="filter.department"
          :items="departments"
          item-title="name"
          return-object
          single-line
          density="compact"
          @update:modelValue="filterChanged"
      >
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 1">
            <span>{{ item.title }}</span>
          </v-chip>
          <span
              v-if="index === 1"
              class="text-grey text-caption align-self-center"
          >
            (+{{ filter.department.length - 1 }} {{ $t('global.text.others') }})
          </span>
        </template>
      </v-select>
    </div>
    <div class="d-flex flex-column flex-md-row">
      <div class="d-flex flex-row">
      <div class="pt-2">{{$t('point-of-sale.filter-form.label.sort-by')}} :&nbsp;</div>
      <v-select
        class="mr-md-5 text-black"
        :label="$t('point-of-sale.filter-form.label.sort-by')"
        :prepend-inner-icon="mdiSort"
        v-model="filter.sortBy"
        :items="sortOptions"
        item-title="label"
        item-value="value"
        single-line
        density="compact"
        @update:modelValue="filterChanged"
      />
      </div>
      <v-btn
        :prepend-icon="mdiRefresh"
        class="my-md-1"
        v-bind="useButtonStyle"
        @click="resetFilter()"
      >
        {{ $t('global.btn.reset') }}
      </v-btn>
    </div>
  </v-card>
</template>

<script setup>
import { reactive, toRefs, watch, computed } from 'vue';
import { mdiMagnify, mdiRefresh, mdiSort } from '@mdi/js';
import { useButtonStyle } from "@/utils/appStyleHandler";
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
  stores: {
    type: Array,
    required: true
  },
  departments: {
    type: Array,
    required: true
  }
});

const { stores, departments } = toRefs(props);

const emit = defineEmits(['filterChanged']);

const sortOptions = computed(() => [
  { label: t('point-of-sale.filter-form.sort-options.date-asc'), value: 'date-asc' },
  { label: t('point-of-sale.filter-form.sort-options.date-desc'), value: 'date-desc' },
  { label: t('point-of-sale.filter-form.sort-options.score-asc'), value: 'score-asc' },
  { label: t('point-of-sale.filter-form.sort-options.score-desc'), value: 'score-desc' }
]);

watch(stores, async () => {
  resetFilter();
});

watch(departments, async () => {
  resetFilter();
});

const filter = reactive({
  search: '',
  store: [],
  department: [],
  sortBy: 'date-asc'
});

function resetFilter() {
  filter.search = '';
  filter.store = [];
  filter.department = [];
  filter.sortBy = 'date-asc';
}

function filterChanged() {
  if (!filter.search) {
    filter.search = '';
  }
  emit('filterChanged', filter);
}

</script>